import { useId } from 'react'

import type { Icon, IconProps } from '@tabler/icons-react'

import type { IconComponent } from '@/lib/icons/types'
import { cn } from '@/lib/utils'

export type CreateIconProps = IconProps & {
  icon: IconComponent | Icon
}

export function CreateIcon({
  icon,
  size = 24,
  stroke = 2,
  title,
  className,
  ...props
}: CreateIconProps) {
  const Base = icon as Icon
  const maskId = `create-icon-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : 'true'}
      role={title ? 'img' : undefined}
      data-slot="create-icon"
      className={cn('shrink-0', className)}
      {...props}
    >
      {title && <title>{title}</title>}
      <mask id={maskId}>
        <rect width="24" height="24" fill="white" />
        <rect x="13" y="13" width="11" height="11" rx="2" fill="black" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <Base stroke={stroke} />
      </g>
      <path d="M16 19h6M19 16v6" />
    </svg>
  )
}
